const gql = {
  query: `query unifiedgraph {
    getStateList
  }`,
  meta: {
    label: "Get State List",
  },
};

export default gql;
